import 'es6-promise/auto';
import('raven-js').then((Raven) => Raven.config('https://f97b1600e44b49b4bcd035e464db6912@sentry.io/1208523').install());

Promise.all([
    import('url-helper'),
    import('raven-js'),
    import('deprecate/main'),
    import('bootstrap/js/dropdown'),
    import('auth-checker'),
    import('tap-side-menu/tap-side-menu'),
]).then((deps) => {
    let [url] = deps;

    function detectGclid()
    {
        var params = url.getQueryParams();
        if (params.gclid) {
            import('cookie-helper').then((cookie) => {
                cookie.set('gclid', params.gclid, 90);
            })

        }
    }

    detectGclid();
})

function setupPricingTableArrows() {
    function repositionPricingTableArrow() {
        var width = $('.pricing-table-arrow').siblings('.plan').width() / 2;
        $('.pricing-table-arrow').css('border-left-width', width + 'px');
        $('.pricing-table-arrow').css('border-right-width', width + 'px');
        $('.pricing-table-arrow').css('border-top-width', (width / 3) + 'px');
    }

    $(window).on('resize', repositionPricingTableArrow);

    repositionPricingTableArrow();
}

setupPricingTableArrows();



// WEBPACK FOOTER //
// ./src/Tap/Bundle/SiteBundle/Resources/private/js/templates/unauth_base.js